var SupportMultipleQtyPopupView, SupportOrderFoodServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View');

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportOrderFoodServiceActionView = (function(superClass) {
  extend(SupportOrderFoodServiceActionView, superClass);

  function SupportOrderFoodServiceActionView() {
    return SupportOrderFoodServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportOrderFoodServiceActionView.prototype.tag = 'td';

  SupportOrderFoodServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportOrderFoodServiceActionView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    if (!this.shouldShowPopup()) {
      return this.addHref(this.getUrlForVoucher(this.order.groupons[0]));
    }
  };

  SupportOrderFoodServiceActionView.prototype.toHash = function() {
    var button_title, hash;
    button_title = this.getSingleActionTitle();
    hash = {
      service_action_id: "order_food",
      service_action: button_title
    };
    if (this.isSingleGroupon()) {
      this.extendSingleGrouponParams(hash);
    }
    return this.extendHash(hash);
  };

  SupportOrderFoodServiceActionView.prototype.actionHandler = function(event) {
    var args, current_order, multipleQtyPopup;
    current_order = Groupon.Support.currentOrder;
    if (this.shouldShowPopup()) {
      args = {
        orders: this.order,
        serviceActionName: 'order_food',
        singleActionButtonCallback: this.getUrlForVoucher,
        showgroupActionButton: false,
        title: this.getSingleActionTitle(),
        singleActionButtonName: this.getSingleActionTitle(),
        showAlertMessage: false
      };
      multipleQtyPopup = new SupportMultipleQtyPopupView(args);
      multipleQtyPopup.render();
    }
    return true;
  };

  SupportOrderFoodServiceActionView.prototype.getSingleActionTitle = function() {
    return I18n.t("js.modules.support.order_food");
  };

  SupportOrderFoodServiceActionView.prototype.shouldShowPopup = function() {
    return !this.isSingleGroupon();
  };

  SupportOrderFoodServiceActionView.prototype.isSingleGroupon = function() {
    return this.order.groupons.length === 1;
  };

  SupportOrderFoodServiceActionView.prototype.getUrlForVoucher = function(groupon) {
    var ref;
    return "/biz/locations/delivery-takeout?merchantId=" + ((ref = this.order.merchant) != null ? ref.uuid : void 0) + "&voucherId=" + groupon.id;
  };

  SupportOrderFoodServiceActionView.prototype.addHref = function(url) {
    return this.$el.find('#order_food').attr('href', url);
  };

  SupportOrderFoodServiceActionView.prototype.events = {
    "click #order_food": "actionHandler"
  };

  return SupportOrderFoodServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportOrderFoodServiceActionView;

//# sourceMappingURL=data:application/json;base64,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
